import { render, staticRenderFns } from "./searchTitles.vue?vue&type=template&id=535b9672&scoped=true&"
import script from "./searchTitles.vue?vue&type=script&lang=js&"
export * from "./searchTitles.vue?vue&type=script&lang=js&"
import style0 from "./searchTitles.vue?vue&type=style&index=0&lang=css&"
import style1 from "./searchTitles.vue?vue&type=style&index=1&id=535b9672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b9672",
  null
  
)

export default component.exports